import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";

function CountryOverview({ country }) {
  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker={`Why ${country.name}`}
          title={country.overview.title}
          description={country.overview.description}
        />

        <div className="mt-10 grid gap-5 md:grid-cols-2 xl:grid-cols-4">
          {country.overview.points.map((point) => (
            <article
              key={point.title}
              className="signature-card signature-card-interactive rounded-2xl p-5"
            >
              <h3 className="text-xl leading-tight">{point.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-text/80">{point.text}</p>
            </article>
          ))}
        </div>
      </div>
    </MotionSection>
  );
}

export default CountryOverview;
